<sw-page class="topdata-es-search-stats-detail-page">
    <template #smart-bar-header>
        <h2 v-if="stats">{{ stats.term }}</h2>
        <h2 v-else>{{ $tc('TopdataEnhancedSearchSW6.topdata-es-search-stats.detail.title') }}</h2>
    </template>

    <template #content>
        <sw-card-view>
            <sw-card
                v-if="stats"
                :title="$tc('TopdataEnhancedSearchSW6.topdata-es-search-stats.detail.termCardTitle')"
            >
                <sw-description-list>
                    <dt>{{ $tc('TopdataEnhancedSearchSW6.topdata-es-search-stats.detail.labelTerm') }}</dt>
                    <dd>{{ stats.term }}</dd>

                    <dt>{{ $tc('TopdataEnhancedSearchSW6.topdata-es-search-stats.detail.labelCount') }}</dt>
                    <dd>{{ stats.count }}</dd>

                    <dt>{{ $tc('TopdataEnhancedSearchSW6.topdata-es-search-stats.detail.labelZeroCount') }}</dt>
                    <dd>{{ stats.zeroCount }}</dd>

                    <dt>{{ $tc('TopdataEnhancedSearchSW6.topdata-es-search-stats.detail.labelAvgResultCount') }}</dt>
                    <dd>{{ stats.avgResultCount }}</dd>

                    <dt>{{ $tc('TopdataEnhancedSearchSW6.topdata-es-search-stats.detail.labelLanguage') }}</dt>
                    <dd>{{ stats.language || $tc('TopdataEnhancedSearchSW6.topdata-es-synonym-suggestion.list.languageGlobal') }}</dd>

                    <dt>{{ $tc('TopdataEnhancedSearchSW6.topdata-es-search-stats.detail.labelNoise') }}</dt>
                    <dd>
                        <sw-label
                            v-if="stats.isNoise"
                            variant="warning"
                            appearance="pill"
                        >
                            {{ noiseReasonLabel(stats.noiseReason) }}
                        </sw-label>
                        <template v-else>—</template>
                    </dd>

                    <dt>{{ $tc('TopdataEnhancedSearchSW6.topdata-es-search-stats.detail.labelCreatedAt') }}</dt>
                    <dd><sw-time-ago v-if="stats.createdAt" :date="stats.createdAt" /></dd>

                    <dt>{{ $tc('TopdataEnhancedSearchSW6.topdata-es-search-stats.detail.labelLastSearchedAt') }}</dt>
                    <dd><sw-time-ago v-if="stats.lastSearchedAt" :date="stats.lastSearchedAt" /><template v-else>—</template></dd>
                </sw-description-list>
            </sw-card>

            <sw-card
                v-else
                :title="$tc('TopdataEnhancedSearchSW6.topdata-es-search-stats.detail.title')"
                :is-loading="isLoading"
            />

            <sw-card
                v-if="stats"
                :title="$tc('TopdataEnhancedSearchSW6.topdata-es-search-stats.detail.processingCardTitle')"
            >
                <sw-description-list
                    v-for="strategy in strategies"
                    :key="strategy"
                >
                    <dt>{{ strategyLabel(strategy) }}</dt>
                    <dd>
                        <template v-if="processingFor(strategy)">
                            <sw-time-ago :date="processingFor(strategy).createdAt" />
                            <span v-if="processingFor(strategy).updatedAt">
                                ({{ $tc('TopdataEnhancedSearchSW6.topdata-es-search-stats.detail.labelUpdated') }}
                                <sw-time-ago :date="processingFor(strategy).updatedAt" />)
                            </span>
                        </template>
                        <template v-else>{{ $tc('TopdataEnhancedSearchSW6.topdata-es-search-stats.detail.neverProcessed') }}</template>
                    </dd>
                </sw-description-list>
            </sw-card>

            <sw-card
                v-if="stats"
                :title="$tc('TopdataEnhancedSearchSW6.topdata-es-search-stats.detail.suggestionsCardTitle')"
            >
                <p v-if="suggestions.length === 0">
                    {{ $tc('TopdataEnhancedSearchSW6.topdata-es-search-stats.detail.noSuggestions') }}
                </p>

                <sw-data-grid
                    v-else
                    :data-source="suggestions"
                    :columns="columns"
                    :show-selection="false"
                    :show-actions="false"
                    :plain-appearance="true"
                >
                    <template #column-suggestionType="{ item }">
                        {{ suggestionTypeLabel(item.suggestionType) }}
                    </template>

                    <template #column-status="{ item }">
                        <sw-label
                            :variant="item.status === 'approved' ? 'success' : (item.status === 'rejected' ? 'danger' : 'warning')"
                            appearance="pill"
                            size="small"
                        >
                            {{ suggestionStatusLabel(item.status) }}
                        </sw-label>
                    </template>

                    <template #column-createdAt="{ item }">
                        <sw-time-ago :date="item.createdAt" />
                    </template>
                </sw-data-grid>
            </sw-card>
        </sw-card-view>
    </template>
</sw-page>
